<template>
  <div>
    <div class="title_">
      计划配置
      <div class="cutoff_"></div>
    </div>
    <a-button type="primary" @click="addPlan">新增计划</a-button>
    <div class="flex_ flex_1">
      <div
        class="mar_r20"
        v-for="(ele, idx) in childInfo.quotationPlans"
        :key="'i' + idx"
      >
        <div class="flex_">
          <label class="wid_160 gray_">计划{{ idx + 1 }}</label>
        </div>
        <div>
          <a-input
            class="wid_100"
            placeholder="计划名称"
            @blur="
              (e) => handleBlur(e.target.value, 'plan', idx, 'planName', ele)
            "
            v-model="ele.planName"
          />
          <a-input
            class="wid_100"
            placeholder="计划代码"
            @blur="
              (e) => handleBlur(e.target.value, 'plan', idx, 'planCode', ele)
            "
            v-model="ele.planCode"
          />

          <a-icon class="icon_" @click="delPlanLsit(ele, idx)" type="minus" />
        </div>
      </div>
    </div>

    <div class="title_">
      险别设置
      <div class="cutoff_"></div>
    </div>
    <a-select
      style="margin-left: 0"
      default-value="1"
      @change="handleLevelChange"
      class="wid_100"
    >
      <a-select-option
        v-for="item in levelList"
        :key="item.value"
        :value="item.value"
      >
        {{ item.name }}
      </a-select-option>
    </a-select>
    <a-button type="primary" @click="addRisk">增加险别</a-button>

    <!-- 以下为可编辑 -->
    <div style="font-weight: bold; color: #f5692c">
      当前编辑: {{ childInfo.editObj.occupationLevel }}类
    </div>
    <div v-for="(item, index) in childInfo.editObj.list" :key="index">
      <div class="flex_">
        <label>险别分类</label>
        <div class="flex_">
          <a-select
            v-model="item.riskType"
            style="wisth: 80px; margin-left: 10px"
          >
            <a-select-option value="1">主险</a-select-option>
            <a-select-option value="2">附险</a-select-option>
          </a-select>
          <a-select
            v-model="item.categoryType"
            placeholder="是否意外身故"
            class="wid_150"
          >
            <a-select-option value="NO">不指定</a-select-option>
            <a-select-option value="YHH">意外身故</a-select-option>
          </a-select>
          <a-input
            class="wid_150"
            v-model="item.coverageName"
            placeholder="险别名称"
          />
          <a-input
            class="wid_150"
            placeholder="险别代码"
            v-model="item.coverageCode"
          />
          
          <a-icon class="icon_" type="minus" @click="delRisk(item, index)" />
        </div>
      </div>
      <div class="flex_ flex_1">
        <div
          class="mar_r20"
          v-for="(ele, idx) in item.planList"
          :key="'i' + idx"
        >
          <div class="flex_">
            <label class="wid_160 gray_">计划：{{ ele.planName }}</label>
          </div>
          <div>
            <a-input
              class="wid_100"
              placeholder="保额"
              v-model="ele.insuredAmount"
              @blur="(e) => handleBlur(e.target.vue, 'setEditObj', idx)"
            />
            <a-input
              class="wid_100"
              placeholder="保费"
              v-model="ele.singlePremium"
              @blur="(e) => handleBlur(e.target.vue, 'setEditObj', idx)"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="title_">
      特殊规则设置
      <div class="cutoff_"></div>
    </div>
    <!-- 特殊类型：保险人数start -->
    <div>
      <div class="flex_">
        <label>保险人数:</label>

        <a-icon
          style="margin-left: 20px"
          class="icon_"
          type="plus"
          @click="addDateData()"
        />
      </div>
      <div class="flex_">
        <label class="wid_160 wid_250 gray_">最小值</label>
        <label class="wid_160 wid_250 gray_">最大值</label>
        <label class="wid_160 wid_250 gray_">职业类别</label>
      </div>
      <div
        class="flex_"
        v-for="(ele, idx) in valiteObj.premiumRules"
        :key="'i' + idx"
      >
        <a-input placeholder="最小值" class="wid_150" v-model="ele.dayMin">
          <a-select
            v-model="ele.dayMinUnit"
            slot="addonAfter"
            style="width: 70px"
          >
            <a-select-option value="n">人数</a-select-option>
            <a-select-option value="p">占比</a-select-option>
          </a-select>
        </a-input>

        ——

        <a-input placeholder="最大值" class="wid_150" v-model="ele.dayMax">
          <a-select
            v-model="ele.dayMaxUnit"
            slot="addonAfter"
            style="width: 70px"
          >
            <a-select-option value="n">人数</a-select-option>
            <a-select-option value="p">占比</a-select-option>
          </a-select>
        </a-input>
        <a-select
          mode="multiple"
          style="width: 400px"
          :default-value="ele.occupationLevel.split(',')"
          @change="(v) => handleChange(v, ele)"
        >
          <a-select-option
            v-for="(item, i) in levelList"
            :key="i"
            :value="item.value"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
        <a-icon
          class="icon_ mar_l15"
          type="minus"
          v-if="valiteObj.premiumRules.length>1"
          @click="deleteDateData(idx)"
        />
      </div>
    </div>
    <!-- 特殊类型：保险人数end -->
    <!-- <div class="right_" style="margin-top: 100px">
      <a-button type="primary" @click="view">查看数据</a-button>
    </div> -->
  </div>
</template>

<script>
import api from "@/utils/sdApi";
export default {
  props: {
    childInfo: {
      type: Object,
      default: function () {
        return {
          quotationPlans: [],
          occupationLevel: "1", //标记当前编辑类别
          quotationCoverageList: [], //所有类别下险别信息列表
          editObj: {
            list: [],
          },
          quotationItems: [],
        };
      },
    },
  },
  data() {
    return {
      valiteObj: this.childInfo.quotationItems[0],
      levelList: [
        {
          name: "1类",
          value: "1",
        },
        {
          name: "2类",
          value: "2",
        },
        {
          name: "3类",
          value: "3",
        },
        {
          name: "4类",
          value: "4",
        },
        {
          name: "5类",
          value: "5",
        },
        {
          name: "6类",
          value: "6",
        },
      ],
    };
  },
  mounted() {
    this.handleLevelChange(1);
    console.log(this.childInfo, "---->childInfo");
  },
  methods: {
    handleChange(value, ele) {
      console.log(value,"--。value")
      ele.occupationLevel = value.join();
      console.log(`selected ${value}`, this.valiteObj);
    },
    //工期
    addDateData() {
      this.valiteObj.premiumRules.push({
        dayMin: "",
        dayMinIsContain: "1",
        dayMinUnit: "n",
        dayMax: "",
        dayMaxIsContain: "1",
        dayMaxUnit: "n",
        occupationLevel: "1",
      });
    },
    deleteDateData(index){
      this.valiteObj.premiumRules.splice(index,1)
    },
    handleBlur(val, type, idex, key, ele) {
      //参数：val-输入框值，type-plan和setEditObj，inex下标，key-planName和planCode
      if (type == "plan") {
        let list = this.childInfo.quotationPlans.filter((item, index) => {
          return index != idex;
        });
        console.log(list, "---->list列表");
        const exit = list.find((item) => {
          return item[key] == val;
        });
        let tip = "代码";
        if (key == "planName") {
          tip = "名称";
        }
        if (exit) {
          this.childInfo.quotationPlans[idex][key] = "";
          this.editPlantoEditObj(key, "", ele);
          this.$notification.warning({ message: `计划${tip}重复` });
        }
        this.editPlantoEditObj(key, val, ele);
      } else if (type == "setEditObj") {
        this.changelLevel(this.childInfo.occupationLevel);
      }
    },
    editPlantoEditObj(key, val, ele) {
      //编辑时更改计划名称和代码
      let reverseKey = "planName";
      if (key == "planName") {
        reverseKey = "planCode";
      }
      let list = [...this.childInfo.editObj.list];
      list.map((item) => {
        let index = item.planList.findIndex((data) => {
          return data[reverseKey] == ele[reverseKey];
        });
        if (index) {
          item.planList[index][key] = val;
        } else {
          console.log(item, "不存在此计划");
        }
      });
      this.childInfo.editObj.list = [...list];
    },
    handleLevelChange(val) {  //类别切换时
      this.childInfo.occupationLevel = val;
      this.changePlanList(val);
      this.changelLevel(val);
    },
    copyTemplate() { //切换类别时：如1类切换到2类时复制1类下的计划险别到2类
      let arr = [];
      let data = this.childInfo.editObj;
      data.list.map((item) => {
        let pList = [];
        this.childInfo.quotationPlans.map((ele) => {
          //根据配置计划生成新类别下的计划
          pList.push({
            ...ele,
            singlePremium: "",
          });
        });
        arr.push({
          ...item,
          planList: pList,
        });
      });
      return arr;
    },
    changePlanList(num) {
      //切换计划列表
      let data = [...this.childInfo.quotationCoverageList];
      let arr = [];
      console.log(data);
      let exit = data.find((ele) => {
        return ele.occupationLevel == num;
      });
      console.log(exit, "----->exit");
      if (exit && exit.list[0]) {
        exit.list[0].planList.map((item) => {
          arr.push({
            planCode: item.planCode,
            planName: item.planName,
          });
        });
        this.childInfo.quotationPlans = arr;
      }
      // else {
      //   this.childInfo.quotationPlans = []  //TODO:可能会优化
      // }
    },
    changelLevel(num) {
      //切换当前编辑类别
      let data = [...this.childInfo.quotationCoverageList];
      let exit = data.find((ele) => {
        return ele.occupationLevel == num;
      });

      if (!exit) {
        data.push({
          occupationLevel: this.childInfo.occupationLevel,
          list: this.copyTemplate(),
        });
        // this.childInfo.editObj = {  //TODO:可能会优化
        //   occupationLevel: num,
        //   list:[]
        // };
      }
      data.map((item) => {
        if (item.occupationLevel == num) {
          this.childInfo.editObj = item;
        }
      });
      this.childInfo.quotationCoverageList = [...data];

      this.emitInfo(this.childInfo);
    },
    emitInfo(data) {
      console.log(data, "子组件");
      data.quotationItems = [this.valiteObj]
      this.$emit("change", data);
    },
    addRisk() {
      const quotationPlans = [...this.childInfo.quotationPlans];
      let arr = [];
      quotationPlans.map((item) => {
        arr.push({
          ...item,
          insuredAmount: "",
          singlePremium: "",
        });
      });
      this.childInfo.editObj.list.push({
        riskType: "1",
        coverageName: "",
        coverageCode: "",
        calculateMethod: 1, //固定值
        forType: 3, //固定值
        planList: arr,
      });
    },
    addPlan() {
      //新增计划
      let list = [...this.childInfo.quotationPlans];
      let num = parseInt(list.length) + 1;
      list.push({
        planName: "计划" + num,
        planCode: "plan" + num,
      });
      this.childInfo.quotationPlans = [...list];
      this.addPlantoEditObj(num);
    },
    addPlantoEditObj(num) {
      //编辑时增加计划
      let list = [...this.childInfo.editObj.list];
      list.map((ele) => {
        ele.planList.push({
          planName: "计划" + num,
          planCode: "plan" + num,
        });
      });
      this.childInfo.editObj.list = [...list];
    },
    delPlanLsit(item, idx) {
      //删除计划
      let list = [...this.childInfo.quotationPlans];
      list.splice(idx, 1);
      this.childInfo.quotationPlans = [...list];
      this.delPlanfromEditObj(item, idx);
      // this.emitInfo(this.childInfo);
    },
    delPlanfromEditObj(item, idx) {
      //编辑时删除计划
      let list = [...this.childInfo.editObj.list];
      list.map((ele) => {
        let index = ele.planList.findIndex((data) => {
          return data.planCode == item.planCode;
        });
        if (index) {
          ele.planList.splice(index, 1);
        } else {
          console.log(ele, "不存在此计划");
        }
      });
      this.childInfo.editObj.list = [...list];
    },
    view() {
      api.saveOrUpdate(this.childInfo.quotationCoverageList);
    },
    delRisk(item, index) {
      let list = [...this.childInfo.editObj.list];
      list.splice(index, 1);
      this.childInfo.editObj.list = [...list];
    },
  },
};
</script>

<style lang="scss" scoped>
.title_ {
  margin: 30px 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: bold;
  clear: both;
  .cutoff_ {
    // width:90%;
    flex: 1;
    height: 5px;
    background: #f0f0f0;
  }
}
.icon_ {
  cursor: pointer;
  margin-right: 10px;
  &:hover {
    color: red;
  }
}
.wid_150 {
  width: 150px;
  margin: 10px;
}
.wid_160 {
  width: 170px;
  margin: 10px;
}
.wid_120 {
  width: 120px;
  margin: 10px;
}
.wid_100 {
  width: 100px;
  margin: 10px;
}
.flex_ {
  display: flex;
  align-items: center;
  .gray_ {
    color: gray;
    margin: 2px 10px;
  }
  label {
    font-weight: bold;
  }
}
.mar_l15 {
  margin-left: 15px;
}
.flex_1 {
  flex-wrap: wrap;
  .mar_r20 {
    margin-right: 20px;
  }
}
</style>